module.exports = __webpack_public_path__ + "img/cajaChicasTalcaGerencial.06cdad67.svg";